import { ComponentProps } from 'react';

import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Breadcrumb } from '@sorare/core/src/components/breadcrumb';
import { HELP } from '@sorare/core/src/constants/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { Search } from 'components/Search';
import { SubmitRequest } from 'components/SubmitRequest';

type Props = {
  sections?: ComponentProps<typeof Breadcrumb>['sections'];
};

export const Header = ({ sections }: Props) => {
  const {
    flags: { useChatBot = false },
  } = useFeatureFlags();

  if (useChatBot) return null;

  return (
    <Vertical>
      <SBHorizontal>
        <Breadcrumb rootTo={HELP} sections={sections} />
        <SubmitRequest size="small" color="tertiary" />
      </SBHorizontal>
      <Search />
    </Vertical>
  );
};
